var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 29,
    viewBox: "0 0 121 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1342)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5476 15.1018V27.3238C41.5476 27.7204 41.2621 28.0433 40.9113 28.0433H36.2411C35.889 28.0433 35.6049 27.7204 35.6049 27.3238V8.02374C35.6049 7.6271 35.8904 7.30425 36.2411 7.30425H40.9113C41.2621 7.30425 41.5476 7.6271 41.5476 8.02374V9.54419C42.7209 7.88538 44.3715 6.84766 46.6828 6.84766C48.8472 6.84766 50.718 7.84387 51.8547 9.71023C53.2482 7.84387 55.2292 6.84766 57.6506 6.84766C61.7593 6.84766 64.5831 9.5857 64.5831 14.8112V27.3238C64.5831 27.7204 64.2976 28.0433 63.9468 28.0433H59.2767C58.9245 28.0433 58.6404 27.7204 58.6404 27.3238V16.2225C58.6404 13.9411 57.5037 12.8219 55.962 12.8219C54.6785 12.8219 53.6507 13.735 53.0633 15.1033V27.3253C53.0633 27.722 52.7778 28.0448 52.427 28.0448H47.7569C47.4047 28.0448 47.1206 27.722 47.1206 27.3253V16.224C47.1206 13.9426 45.984 12.8234 44.4422 12.8234C43.122 12.8234 42.1309 13.7366 41.5435 15.1048",
    fill: "#B7B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3939 28.4585C68.946 28.4585 66.0474 25.8865 66.0474 21.9047C66.0474 18.255 68.1751 16.5531 72.137 15.3924L77.2001 13.8996C77.0532 12.5314 76.0988 11.8672 74.5584 11.8672C73.1934 11.8672 72.2117 12.4576 71.759 13.6383C71.6326 13.9673 71.3294 14.161 71.0194 14.078L67.0072 12.9987C66.6374 12.8988 66.4213 12.453 66.5531 12.0502C67.7047 8.52655 70.9052 6.68018 74.7773 6.68018C79.9859 6.68018 82.9946 9.45973 82.9946 14.3532V27.3224C82.9946 27.7205 82.7091 28.0418 82.3583 28.0418H77.9302C77.5848 28.0418 77.302 27.7298 77.2939 27.3393L77.2721 26.2585L77.2354 26.3C75.7317 27.7513 74.2647 28.4569 72.3926 28.4569M73.8963 23.2714C74.6672 23.2714 75.2531 23.0223 76.1341 22.4412L77.1606 21.7356L77.1973 18.3749L74.5557 19.2051C72.7583 19.7862 71.9507 20.2843 71.9507 21.445C71.9507 22.7303 72.9405 23.2699 73.8949 23.2699",
    fill: "#B7B1B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4832 18.255L90.6858 20.1214V27.3239C90.6858 27.7221 90.4003 28.0434 90.0495 28.0434H85.4894C85.1373 28.0434 84.8531 27.7206 84.8531 27.3239V1.21949C84.8531 0.822846 85.1387 0.5 85.4894 0.5H90.0495C90.4003 0.5 90.6858 0.822846 90.6858 1.21949V13.028L96.0059 7.49347C96.1228 7.37201 96.2778 7.30283 96.4368 7.30283H102.067C102.649 7.30283 102.925 8.11149 102.497 8.55425L97.0337 14.1887L103.263 26.9765C103.497 27.4561 103.19 28.0434 102.706 28.0434H97.3831C97.1466 28.0434 96.9277 27.8943 96.8189 27.656L92.4845 18.2535L92.4832 18.255Z",
    fill: "#B7B1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.834 28.4999C106.736 28.4999 102.076 24.8917 102.076 17.5908C102.076 10.7049 106.552 6.72314 111.467 6.72314C116.382 6.72314 120.272 10.7464 120.417 17.0927C120.434 17.763 120.443 18.2303 120.449 18.5624C120.454 18.9652 120.167 19.2911 119.812 19.2911H107.946C108.129 21.7801 109.89 23.3559 112.128 23.3559C113.72 23.3559 115.025 22.6072 115.94 21.2543C116.143 20.9545 116.517 20.8853 116.794 21.096L119.758 23.3405C120.054 23.565 120.128 24.02 119.928 24.3536C118.34 26.9964 115.721 28.4999 111.836 28.4999M108.057 15.2263H114.477C114.441 12.8618 112.9 11.8257 111.286 11.8257C109.783 11.8257 108.242 12.8219 108.059 15.2263",
    fill: "#B7B1B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_1342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 7,
    width: 6,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.665 7.31665H26.2713C26.622 7.31665 26.9075 7.6395 26.9075 8.03614V27.2639C26.9075 27.6606 26.622 27.9834 26.2713 27.9834H21.665C21.3142 27.9834 21.0287 27.6606 21.0287 27.2639V8.03614C21.0287 7.6395 21.3142 7.31665 21.665 7.31665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_1342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2057 5.1579L15.0974 9.78931L21.7336 30.1406L32.8419 25.5092L26.2057 5.1579Z",
    fill: "#B7B1B1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10_1342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 14,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1534 7.57022L0.517948 24.7503C0.360236 25.1054 0.486678 25.5374 0.800743 25.7157L4.91622 28.0541C5.23028 28.2324 5.61233 28.0894 5.77004 27.7343L13.4055 10.5542C13.5632 10.1991 13.4368 9.76712 13.1227 9.58878L9.00722 7.25045C8.91477 7.19818 8.81824 7.17358 8.72171 7.17358C8.48922 7.17358 8.26488 7.3181 8.1534 7.57022Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10_1342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4843 1.73686L-6.42517 10.4919L2.4381 33.6741L20.3475 24.919L11.4843 1.73686Z",
    fill: "#B7B1B1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10_1342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 7,
    width: 10,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 7.63183L11.309 26.3585C11.241 26.7474 11.4639 27.1241 11.8079 27.2025L16.3231 28.2325C16.6684 28.3109 17.0056 28.0572 17.0736 27.6668L20.3407 8.94013C20.4087 8.55118 20.1857 8.17452 19.8417 8.09612L15.3265 7.06608C15.2844 7.05686 15.2422 7.05225 15.2001 7.05225C14.9023 7.05225 14.6359 7.289 14.576 7.63183Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10_1342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3142 3.69197L5.14551 9.58984L12.3355 31.6749L26.5041 25.777L19.3142 3.69197Z",
    fill: "#B7B1B1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 28,
    fill: "white",
    transform: "translate(0.449951 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMake);
export default __webpack_public_path__ + "static/media/Make.491292a8bc17d279236bee6919d5aad6.svg";
export { ForwardRef as ReactComponent };